import { render, staticRenderFns } from "./SideCategoryLink.vue?vue&type=template&id=892af7ac&scoped=true&"
import script from "./SideCategoryLink.vue?vue&type=script&lang=js&"
export * from "./SideCategoryLink.vue?vue&type=script&lang=js&"
import style0 from "./SideCategoryLink.vue?vue&type=style&index=0&id=892af7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892af7ac",
  null
  
)

export default component.exports